import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight } from "lucide-react";

const STEPS = [
  { to: "/clientes", title: "Complete la ficha del cliente", text: "Abra Clientes → IMB Services LLC y agregue correo, teléfono y contacto. Use un correo suyo para recibir las facturas y avisos de prueba." },
  { to: "/usuarios", title: "Cree el acceso del cliente", text: "En Usuarios cree un usuario con rol Cliente ligado a IMB Services. Así podrá entrar al portal como lo haría su cliente." },
  { to: "/propuestas/nueva", title: "Envíe una propuesta", text: "En Propuestas → Nueva elija IMB Services y un plan (por ejemplo Plan Emprendedor $1,100) y envíela." },
  { to: "/login", title: "Acepte la propuesta como cliente", text: "Cierre sesión, entre con el usuario cliente, abra Mis propuestas y acéptela. Luego vuelva a entrar con su cuenta de administrador." },
  { to: "/proyectos", title: "Revise el proyecto y sus tareas", text: "Al aceptar se crea el proyecto. En Tareas mueva las tarjetas entre columnas para ver el avance." },
  { to: "/facturas", title: "Genere la factura", text: "En Facturas cree o revise la factura del plan y descargue el PDF para ver cómo la recibirá el cliente." },
  { to: "/pagos", title: "Registre un pago", text: "En Pagos registre el pago de la factura. Verá que cambia a Pagada y aparece en los ingresos." },
  { to: "/proyectos", title: "Entregue el proyecto", text: "En el proyecto pulse Entregar. Se crean las renovaciones de dominio y correo y se ofrece el mantenimiento gratis el primer año." },
  { to: "/renovaciones", title: "Revise renovaciones y alertas", text: "En Renovaciones verá las fechas de vencimiento, las alertas y la aprobación del cliente." },
  { to: "/reportes", title: "Vea sus reportes", text: "En Reportes de ingresos revise las gráficas y descargue el reporte en PDF, CSV o Excel." },
  { to: "/plantillas", title: "Active los correos (opcional)", text: "Las plantillas de correo están apagadas. Actívelas en Correos → Plantillas cuando quiera que se envíen avisos reales." },
];

const KEY = "rino-help-done";

function Step({ s, i, done, toggle }) {
  return (
    <li className={`card-box card-lift fade-up flex gap-4 p-5 ${done ? "opacity-70" : ""}`} data-testid={`help-step-${i + 1}`}>
      <button onClick={toggle} aria-label="Marcar paso" className="mt-0.5 shrink-0 text-blue-600" data-testid={`help-step-toggle-${i + 1}`}>
        {done ? <CheckCircle2 className="h-6 w-6 text-emerald-600" /> : <Circle className="h-6 w-6" />}
      </button>
      <div className="flex-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-blue-600">Paso {i + 1}</p>
        <h3 className={`font-display text-lg font-bold text-slate-900 ${done ? "line-through" : ""}`}>{s.title}</h3>
        <p className="mt-1 text-sm text-slate-600">{s.text}</p>
        <Link to={s.to} className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-blue-700 hover:underline" data-testid={`help-step-link-${i + 1}`}>Ir ahora <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </li>
  );
}

export default function Help() {
  const [done, setDone] = useState(() => JSON.parse(localStorage.getItem(KEY) || "[]"));
  const toggle = (i) => {
    const next = done.includes(i) ? done.filter((x) => x !== i) : [...done, i];
    setDone(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  };
  return (
    <div className="mx-auto max-w-3xl" data-testid="help-page">
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-900">Guía de prueba</h1>
      <p className="mt-2 text-slate-600">Siga estos pasos con IMB Services LLC para conocer todo el recorrido antes de publicar. Marque cada paso al terminarlo.</p>
      <p className="mt-4 text-sm font-semibold text-slate-700" data-testid="help-progress">{done.length} de {STEPS.length} pasos completados</p>
      <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-200"><div className="h-full bg-gradient-to-r from-blue-600 to-orange-500 transition-[width]" style={{ width: `${(done.length / STEPS.length) * 100}%` }} /></div>
      <ol className="stagger mt-8 space-y-4">{STEPS.map((s, i) => <Step key={s.title} s={s} i={i} done={done.includes(i)} toggle={() => toggle(i)} />)}</ol>
    </div>
  );
}
